<div
  class="ant-tabs-nav-wrap ui-tabs-nav-wrap"
  #navWarp
  [class.ant-tabs-nav-wrap-ping-left]="pingLeft"
  [class.ant-tabs-nav-wrap-ping-right]="pingRight"
  [class.ant-tabs-nav-wrap-ping-top]="pingTop"
  [class.ant-tabs-nav-wrap-ping-bottom]="pingBottom">
  <div class="ant-tabs-nav-list ui-tabs-nav-list" #navList (offsetChange)="onOffsetChange($event)" (tabScroll)="tabScroll.emit($event)" uiTabScrollList role="tablist">
    <ng-content></ng-content>
    <button *ngIf="showAddButton" [addIcon]="addIcon" (click)="addClicked.emit()" ui-tab-add-button></button>
    <div [hidden]="hideBar" [position]="position" [animated]="inkBarAnimated" ui-tabs-ink-bar></div>
  </div>
</div>
<ui-tab-nav-operation [addIcon]="addIcon" [addable]="addable" [items]="hiddenItems" (addClicked)="addClicked.emit()" (selected)="onSelectedFromMenu($event)"></ui-tab-nav-operation>
<div class="ant-tabs-extra-content" *ngIf="extraTemplate">
  <ng-template [ngTemplateOutlet]="extraTemplate"></ng-template>
</div>
